import { render, staticRenderFns } from "./ticketList.vue?vue&type=template&id=638b1f85&scoped=true&"
import script from "./ticketList.vue?vue&type=script&lang=js&"
export * from "./ticketList.vue?vue&type=script&lang=js&"
import style0 from "./ticketList.vue?vue&type=style&index=0&id=638b1f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638b1f85",
  null
  
)

export default component.exports